import Vue from 'vue'
import VueRouter from 'vue-router'
import TokenService from '../helpers/token'
import { updateProfileInto, checkMobile } from '../helpers/utils'
import RepositoryFactory from '../repositories/RepositoryFactory'
import AuthLayout from '../layouts/AuthLayout'

// pages
import Error403 from '../pages/Error403'
import Login from '../pages/Login'

// stores
import store from '@/store';
import { PARTNER } from "../layouts/dashboard/DrawerNew"
import {KHTN, TA_ERP, TOAN_ERP} from "@/helpers/constants";

const AuthRepository = RepositoryFactory.get('auth')
const SchoolLevelRepository = RepositoryFactory.get('school_level')
const TypeRepository = RepositoryFactory.get('type')
const CoreActionsLogRepository = RepositoryFactory.get('core_actions_log')
const UserRepository = RepositoryFactory.get('user')
const ConfigRepository = RepositoryFactory.get('configErp')

const { userMenu } = require('./user')

const { productMenu } = require('./product')

const { contactMenu, getBreadcrumb } = require('./contact')

const { CallCenterMenu } = require('./callCenter')

const { profileMenu } = require('./profile')

const { reportMenu } = require('./report')

const { settingMenu } = require('./setting')

const { dataSetting } = require('./dataSetting')

const { orderMenu } = require('./order')

const { supportMenu } = require('./support')

const { supportMenuV2 } = require('./supportv2')

const { dashboardMenu } = require('./dashboard')

const { smsMenu } = require('./sms')

const { reportThptMenu } = require('./reportThpt')

const { storeMenu } = require('./store')

const { trainingMenu } = require('./training')

const { reportMktMenu } = require('./reportMkt')

const { transactionHistoryMenu } = require('./transactionHistory')

const { policyPartnerMenu } = require('./policyPartner')

const { errorProductMenu } = require('./errorProduct')

const { tutorTestMenu } = require('./tutorTest')

const { tutorMenu } = require('./tutor')

const { allotmentMenu } = require('./allotment')

const { zaloContactList } = require('./zalo')

const { agencyList } = require('./agency')
const { teacherSupportV2 } = require('./teacher-support')
const { bituChat } = require('./bituchat')

const { scriptMenu, scriptManageMenu, manageBrandName  } = require('./script')

const { qrTransactionMenu } = require('./qrTransaction')

const permission = TokenService.getPermissions();
let isDashboardRole = permission.includes("dashboard_read");
let listSchoolLevel = [];
let listType = [];
let listActionLogType = [];
let listModuleUser = [];

const authPages = {
  path: '/',
  component: AuthLayout,
  name: 'Authentication',
  children: [
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        onlyWhenLoggedOut: true,
        public: true,
      },
    },
    {
      path: '/error-403',
      name: 'Error403',
      component: Error403,
      meta: {
        layout: 'login',
        public: true,
      },
    },
  ],
}

const routes = [
  {
    path: '/',
    redirect: isDashboardRole ? '/dashboard' : '/contact/contact-list',
    name: 'Home',
  },
  authPages,
  profileMenu,
  productMenu,
  userMenu,
  contactMenu,
  CallCenterMenu,
  orderMenu,
  reportMenu,
  dataSetting,
  settingMenu,
  supportMenu,
  supportMenuV2,
  dashboardMenu,
  smsMenu,
  reportThptMenu,
  storeMenu,
  trainingMenu,
  reportMktMenu,
  transactionHistoryMenu,
  policyPartnerMenu,
  errorProductMenu,
  tutorTestMenu,
  allotmentMenu,
  zaloContactList,
  agencyList,
  scriptMenu,
  scriptManageMenu,
  manageBrandName,
  teacherSupportV2,
  bituChat,
  qrTransactionMenu,
  tutorMenu // luôn để ở cuối cùng
]
Vue.use(VueRouter)

// configure router
const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior: (to) => {
    if (to.hash) {
      return { selector: to.hash }
    }
    return { x: 0, y: 0 }
  },
  linkExactActiveClass: 'nav-item active',
})

// eslint-disable-next-line consistent-return
router.beforeEach(async (to, from, next) => {
   const isPublic = _.get(to.meta, 'public', false)
  const onlyWhenLoggedOut = _.get(to.meta, 'onlyWhenLoggedOut', false)
  const loggedIn = !!TokenService.getToken()
  const isMobile = checkMobile()
  const { title, description } = to.meta;
  const defaultTitle = 'VH - CRM';
  console.log('to', to);
  if (to.query && to.query.order) {
    document.title = `DH${to.query.order} CRM`;
  } else {
    document.title = title || defaultTitle;
  }
  if (loggedIn) {
    // get user's profile
    const profile = await AuthRepository.profile();
    const resCheckMinistryAvailable = await AuthRepository.checkMinistryAvailable({userId: _.get(profile, 'data.id', 0)});
    if (resCheckMinistryAvailable && resCheckMinistryAvailable.success){
      store.commit('SET_CALL_WITH_BRAND_NAME',resCheckMinistryAvailable.data.isOk);
    }

    const profileTeacher = await AuthRepository.getInfoTeacherApi()
    TokenService.setTeacherInfo(_.get(profileTeacher, 'data'))

    updateProfileInto(_.get(profile, 'data'))
    store.dispatch('SET_PERMISSION', _.get(profile, 'data.role.permissions', []).map(p => `${p.model}_${p.action}`))
    store.dispatch('SET_MANAGER', _.get(profile, 'data.isManager', 0))

    const moduleReportPermission = await  AuthRepository.getModuleReportPermissionApi();
    store.dispatch('SET_PERMISSION_MODULE_REPORT', moduleReportPermission.success);
    if(moduleReportPermission.status === 400 && to.name === 'GeneralModuleReport') {
      return next('/error-403');
    }
    // get list school-level, type
    await Promise.all([
      getListSchoolLevel(),
      getListType(),
      getActionLogTypeList(),
      getListModuleUser()
    ]);
    store.dispatch('SET_LIST_TYPE', _.get(listType, 'data', []))
    store.dispatch('SET_LIST_SCHOOL_LEVEL', _.get(listSchoolLevel, 'data', []))
    store.dispatch('SET_LIST_ACTION_LOG_TYPE', _.get(listActionLogType, 'data', []))
    store.dispatch('SET_LIST_MODULE_USER', listModuleUser || [])

    if (!_.isEmpty(TokenService.getModule()) &&
        (checkModuleInToken(TokenService.getModule()) || _.get(profile, 'data.isManager', 0))
    ) {
      store.dispatch('SET_MODULE', TokenService.getModule())
    } else {
      store.dispatch('SET_MODULE', {
        typeId: _.get(profile, 'data.typeId', ''),
        schoolLevelId: _.get(profile, 'data.schoolLevelId', '')
      })
      TokenService.setModule({
        typeId: _.get(profile, 'data.typeId', ''),
        schoolLevelId: _.get(profile, 'data.schoolLevelId', '')
      })
    }
    const response = await ConfigRepository.getConfigErp();
    const subjects = response.data.find(i => i.type == 'subject')?.data;
    const subLevels = response.data.find(i => i.type == 'sub_level')?.data;
    const levels = response.data.find(i => i.type == 'level');
    const LEVEL_MATH = levels.data.filter(s => s.subjectId == TOAN_ERP);
    const LEVEL_ENGLISH = levels.data.filter(s => s.subjectId == TA_ERP);
    const LEVEL_KHTN = levels.data.filter(s => s.subjectId == KHTN);
    const listUserNeedRedirect =  response.data.find(i => i.type == 'list_user_need_redirect');
    const redirectDomain =  response.data.find(i => i.type == 'redirect_domain');
    const listUserException =  response.data.find(i => i.type == 'list_user_exception_list');
    const domain = redirectDomain && redirectDomain.data && redirectDomain.data.crm ? redirectDomain.data.crm : {};
    const domainWithTime = Object.assign({}, domain, { current_time: response.currentTime });

    store.dispatch('setListUserNeedRedirect',listUserNeedRedirect && listUserNeedRedirect.data ? listUserNeedRedirect.data: []);
    store.dispatch('setRedirectDomain', domainWithTime);
    store.dispatch('setListUserException',listUserException && listUserException.data ? listUserException.data: []);

    store.dispatch('updateConfig', {
      mathLevels: LEVEL_MATH,
      englishLevels: LEVEL_ENGLISH,
      khtnLevels: LEVEL_KHTN,
      subjects,
      subLevels,
    });

  } else {
    TokenService.removeModule()
  }

  if (loggedIn && isMobile && to.fullPath == '/orders/order-list') {
    return next('/mobile/orders/order-list')
  }

  if (loggedIn && isMobile && to.fullPath == '/customer-support') {
    return next('/mobile/customer-support')
  }
  if (loggedIn && isMobile && to.fullPath == '/customer-support-new') {
    return next('/mobile/customer-support-new')
  }

  if (loggedIn && isMobile && to.fullPath == '/orders/' + to.params.id + '/account') {
    return next('/mobile' + to.fullPath)
  }

  if (loggedIn && isMobile && to.fullPath == '/profile') {
    return next('/mobile/profile')
  }

  if ((to.fullPath == '/report/employee-report-' + to.params.id) && to.params.id !== PARTNER && to.path !== '/error-403') {
    return next('/error-403')
  }

  if (isPublic) next()
  if (!isPublic && !loggedIn) {
    return next({
      path: '/login',
      query: { redirect: to.fullPath }, // Store the full path to redirect the user to after login
    })
  }

  // Do not allow user to visit entry page if they are logged in
  if (loggedIn && onlyWhenLoggedOut) {
    return next('/dashboard')
  }

  // xu ly breadcrumb
  if(to.name === 'OrderCreate' || to.name === 'ContactHistory') {
    to.meta.breadcrumb = getBreadcrumb(to)
  }

  if (to.name == 'AgencyOrderCreate') {
    to.meta.breadcrumb = [{
      title: 'Quản lý đại lý',
      to: '/agency',
    }, {
      title: 'Chi tiết đại lý',
      to: `/agency/detail/${to.params.id}`,
    }, {
      title: 'Tạo Đơn hàng',
    }]
  }

  if (to.name == 'AgencyOrderEdit') {
    to.meta.breadcrumb = [{
      title: 'Quản lý đại lý',
      to: '/agency',
    }, {
      title: 'Chi tiết đại lý',
      to: `/agency/detail/${to.params.id}?tabIndex=1`,
    }, {
      title: 'Thông tin Đơn hàng',
    }]
  }

  // check role of user
  if (loggedIn) {
    // check permission
    const metaRole = _.get(to.meta, 'roles', []);

    if (metaRole === 'all') {
      next();
    } else {
      const userPermissions = TokenService.getPermissions();
      const storePermissions = store.state.permissions

      if (!_.intersection(metaRole, userPermissions).length
        && !_.intersection(metaRole, storePermissions).length && to.path !== '/error-403') {
        return next('/error-403');
      }
    }
  }
  next()
})

export async function getListSchoolLevel() {
  listSchoolLevel = await SchoolLevelRepository.list()
}

export async function getListType() {
  listType = await TypeRepository.list()
}

export async function getActionLogTypeList() {
  listActionLogType = await CoreActionsLogRepository.listActionLogType();
}
export async function getListModuleUser () {
  let response = {};
  response = await UserRepository.listModuleView()
  listModuleUser = response?.data || null
}
export function checkModuleInToken (moduleUserInToken) {
  let checkType = listModuleUser.find(item => item.id == moduleUserInToken.typeId);
  if (!checkType) return false;
  let schoolLevelOfType = checkType?.schoolLevel || []
  let checkSchoolLevel = schoolLevelOfType.find(item => item.id == moduleUserInToken.schoolLevelId);
  if (!checkSchoolLevel) return false
  return true;
}
export default router
